// extracted by mini-css-extract-plugin
module.exports = {"CopyToClipboardButton__button":"CopyToClipboardButton__button--769d1","CopyToClipboardButtonButton":"CopyToClipboardButton__button--769d1"};